let cached = null;

export async function getConfig() {
  if (cached) return cached;
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`);
    cached = res.ok ? await res.json() : {};
  } catch {
    cached = {};
  }
  return cached;
}

export function clearConfigCache() {
  cached = null;
}
